<template>
    <div>
        <a id="topID"></a>
        <div id="hd" >
            <a id="snbOpen"><span class="sound_only">Open SideMenu</span></a>
        </div>
        <nav id="gnb" >
            <h2>Main-Menu</h2>
            <div class="gnb_wrap" >
                <a href="" class="btn-logo"><img src="/img/common/logo.png"></a>
            </div>
            <p class="clb"></p>
            <div class="top-link">
                <router-link v-if="this.isAuthenticated" to="/account" type="button">Account Summary</router-link>
                <router-link v-if="!this.isAuthenticated" to="/register" type="button">Register</router-link>
                <!--로그아웃 상태일때에만 login 메뉴를 보여준다 -->
                <router-link v-if="!this.isAuthenticated" to="/login" type="button" >Login</router-link>
                <router-link v-else to="/logout" @click.native="logout" type="button"  >Logout</router-link>
            </div>
        </nav>
        <aside id="sideBarCover"></aside>
    </div>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import { mapGetters } from "vuex"
import store from "../store/store"

export default {
    components: {
        BaseNav,
        CloseButton,
        BaseDropdown
    },
    computed: {
        ...mapGetters(["isAuthenticated"]),
    },
    watch: {
        /*
         router path가 변경될 때를 감지하기 위해서 추가.
         http://~~/refer/sharekey가 바뀔때 vue는 화면을 다시 로드하지 않기 때문에 제대로 바뀐 파라미터가 반영이 되지 않는다.
         따라서 $route()를 통해서 route path가 바뀌는 것을 감지하고 sharekey를 반영해 준다.
        */
        $route(to, from) {
            let sharekey = '';
            const fromName = from.name;
            //console.log("fromName=" + fromName + ", toName=" + toName);
            if (fromName === 'Main_with_sharekey') {
                sharekey = from.params.sharekey;
                //console.log('from sharekey=' + sharekey);
            }
            const toName = to.name;
            if (toName === 'Main_with_sharekey') {
                sharekey = to.params.sharekey;
                //console.log('to sharekey=' + sharekey);
            }
            if (sharekey) {
                console.log('setReferShareKey=' + sharekey);
                store.commit('setReferShareKey', sharekey);
            }
            //console.log("refer-share-key=" + this.$store.getters.getReferShareKey);
        }

    },
    mounted() {
        let sharekey = this.$route.params.sharekey;
        let centercode = this.$route.params.centercode;
        if (sharekey) {
            console.log('mounted - sharekey=' + sharekey);
            store.commit('setReferShareKey', sharekey);
        }
        if (centercode) {
            console.log('mounted - centercode=' + centercode);
            store.commit('setReferCenterCode', centercode);
        }
        //console.log("refer-share-key=" + this.$store.getters.getReferShareKey);
        $("#gnb").show();
    },
    methods: {
        redirect() {
            if (!this.isAuthenticated) {
                this.$router.push('/');
            }
        },
        logout() {
            this.$store
                .dispatch("logout", {})
                .then(() => this.redirect())
                .catch(({ message }) => alert(message))
        },
    }
};
</script>
<style>
</style>
